import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'light';
  href?: string;
  className?: string;
};
export function CtaButton({
  children,
  variant = 'primary',
  href = '#oferta',
  className = ''
}: CtaButtonProps) {
  const styles = variant === 'primary' ? 'bg-primary text-white shadow-[0_10px_24px_-10px_rgba(47,95,91,0.7)] hover:bg-primary-dark focus-visible:ring-primary' : 'bg-cream text-primary-dark shadow-[0_10px_24px_-10px_rgba(0,0,0,0.4)] hover:bg-white focus-visible:ring-cream';
  return <a href={href} className={`group inline-flex w-full items-center justify-center gap-2 rounded-full px-8 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 sm:w-auto sm:px-10 sm:py-5 sm:text-base ${styles} ${className}`} data-id="element-62" data-mp="2jgge2x9qozvu">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-63" data-mp="2h9apgsw075oc" />
    </a>;
}